import { Record, ShowControllerProps, useShowContext } from "ra-core";
import { ReactElement } from "react";

interface WithShowRender<R extends Record> {
  (x: Partial<ShowControllerProps<R>>): ReactElement|null
}


function WithShow<R extends Record>(x: { render: WithShowRender<R> }) {
  const { render } = x
  const showCtx = useShowContext<R>()
  return render(showCtx)
}

export default WithShow;
